<template>
    <div class="container">
        <div class="row justify-content-center bg-white">
            <div class="col-12 col-sm-10">
                <div class="card shadow-sm" v-if="user != null">
                    <div class="card-body">
                        <div
                            class="d-flex justify-content-between align-items-center mb-3"
                        >
                            <h2 class="h2 mb-0">
                                {{ t("ai.recharge-title") }}
                            </h2>
                            <!-- Local escolhido para mostrar os créditos em conta -->
                            <span class="badge bg-secondary text-white"
                                >Saldo: R$
                                {{
                                    Number(user.ai_credits)
                                        .toFixed(2)
                                        .replace(".", ",")
                                }}</span
                            >
                        </div>

                        <p class="text-muted small mb-4">
                            Insira o valor que deseja adicionar aos seus
                            créditos de IA.
                        </p>

                        <form @submit.prevent="send">
                            <div class="mb-3">
                                <label for="amount" class="form-label"
                                    >Valor a recarregar</label
                                >
                                <input
                                    id="amount"
                                    name="amount"
                                    type="number"
                                    step="0.01"
                                    v-model="amount"
                                    min="1.00"
                                    class="form-control"
                                    placeholder="1.00"
                                    aria-label="Valor a recarregar"
                                    required
                                />
                                <div class="form-text">
                                    Digite o valor em R$ (Brl).
                                </div>
                            </div>

                            <div class="d-grid">
                                <button type="submit" class="btn btn-primary">
                                    Recarregar
                                </button>
                            </div>
                        </form>

                        <hr />

                        <div class="text-center small text-muted">
                            Ao confirmar, o valor será convertido em créditos de
                            IA e adicionado à sua conta.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { t } from "@/lang";

export default {
    name: "AiRecharge",
    data() {
        return {
            user: null,
            amount: 1.0,
        };
    },
    async created() {
        document.title = "Recharge";
        this.SET_LOADING(true);
        await this.getUser();
        this.SET_LOADING(false);
    },
    computed: {
        ...mapState(["loading"]),
    },
    methods: {
        ...mapActions(["get", "post", "put", "delete"]),
        ...mapMutations(["SET_LOADING"]),
        t,
        async send() {
            this.SET_LOADING(true);
            try {
                const response = await this.get({
                    url: `payment/ai-recharge?amount=${this.amount}`,
                });
                if (response.status == 200) {
                    console.log(response.data);
                    open(response.data.url);
                } else {
                    alert(response.data.message);
                }
            } catch (e) {
                console.log(e);
                if (e.data?.message) {
                    alert(e.data?.message);
                } else {
                    alert("error");
                }
            }
            this.SET_LOADING(false);
        },
        async getUser() {
            const response = await this.get({ url: "user" });
            console.log(response.data);
            if (response.status == 200) {
                this.user = response.data.user;
            } else {
                alert(response.data.message);
            }
        },
    },
};
</script>
